export type TokenMatch = {
  name: string
  start: number
  end: number
}

// carrot-app ports this pattern in Carrot.Content/Utilities/TextTokenParser.cs to render the same content
// server-side (help center, Decagon). Change both together, or the same body reads differently per surface.
const TOKEN_PATTERN = /\[\[([a-z0-9-]+)\]\]/g

export function findTokens(input: string): TokenMatch[] {
  if (!input) return []
  const matches: TokenMatch[] = []
  for (const match of input.matchAll(TOKEN_PATTERN)) {
    matches.push({
      name: match[1],
      start: match.index ?? 0,
      end: (match.index ?? 0) + match[0].length
    })
  }
  return matches
}
